'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContactsController = function () {
    function ContactsController($state, $stateParams, $ionicScrollDelegate) {
        _classCallCheck(this, ContactsController);

        this.$state = $state;
        this.contactType = $stateParams.defaultTab;
        this.callingPage = $stateParams.callingPage;
        this.$ionicScrollDelegate = $ionicScrollDelegate;
    }

    _createClass(ContactsController, [{
        key: 'init',
        value: function init() {
            var _this = this;

            this.showSortOrderCmb = true;

            this.isFilterActive = function () {
                return _this.filterIndicationText && _this.filterIndicationText.length > 0;
            };

            this.sortOrder = {
                value: 'AUM_DESC',
                field: 'AUM',
                order: 'DESC',
                type: 'AUM'
            };

            this.sortCriteria = [{
                value: 'ACCOUNT_ASC',
                field: 'ACCOUNT_NAME',
                order: 'ASC',
                type: 'ACCOUNT'
            }, {
                value: 'ACCOUNT_DESC',
                field: 'ACCOUNT_NAME',
                order: 'DESC',
                type: 'ACCOUNT'
            }, { value: 'AUM_DESC', field: 'AUM', order: 'DESC', type: 'AUM' }, { value: 'AUM_ASC', field: 'AUM', order: 'ASC', type: 'AUM' }, {
                value: 'LAST_NAME_ASC',
                field: 'LAST_NAME',
                order: 'ASC',
                type: 'NAME'
            }, {
                value: 'LAST_NAME_DESC',
                field: 'LAST_NAME',
                order: 'DESC',
                type: 'NAME'
            }, { value: 'TITLE_ASC', field: 'TITLE', order: 'ASC', type: 'TITLE' }, {
                value: 'TITLE_DESC',
                field: 'TITLE',
                order: 'DESC',
                type: 'TITLE'
            }];

            this.onAssignContactsClick = function (e) {
                // prevent disappering of button from campaign-detail page
                // to avoid the dropdow options from poping up
                _this.showSortOrderCmb = false;
                if (_this.callingPage !== 'campaignDetail') _this.showCheckboxes = !_this.showCheckboxes;
                _this.assignContacts();
            };

            this.updateDisable = function (flag) {
                _this.disabled = flag;
            };
        }
    }, {
        key: 'onTabChange',
        value: function onTabChange(type) {
            this.contactType = type;
            this.$ionicScrollDelegate.scrollTop();
        }
    }]);

    return ContactsController;
}();

exports.default = ContactsController;


/** WEBPACK FOOTER **
 ** ./src/app/components/contacts/contacts.controller.js
 **/